module.exports = __webpack_public_path__ + "static/white_logo-b8eb662944bba808e1fe7a23142f7fa2.png";